/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {AnimaPulse2} from '../../assets/animation/styles'
import {toAbsoluteUrl} from '../../helpers'
import {useLayout} from '../core'

const Footer: FC = () => {
  const {classes} = useLayout()
  return (
    <div className='footer py-4 d-flex flex-lg-column' id='kt_footer'>
      {/* begin::Container */}
      <div
        className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        {/* begin::Copyright */}

        <AnimaPulse2>
          <div className='text-dark'>
            <a href='https://ambipar.com' className='mb-6'>
              <img
                alt='Ambipar Response'
                src={toAbsoluteUrl('/media/logos/ambipar_response_black.png')}
                className='h-35px mb-0 mt-0'
              />
            </a>
            <span className=' fw-bold'>&copy;{new Date().getFullYear()}</span>
          </div>
        </AnimaPulse2>

        {/* end::Copyright */}

        {/* begin::Nav */}
        <ul className='menu menu-gray-600 menu-hover-primary fw-bold order-1'>
          {/* <li className='menu-item'>
            <a href='#' className='menu-link ps-0 pe-2'>
              About
            </a>
          </li> */}
          <li className='menu-item'>
            <a
              href='#'
              className='menu-link pe-0 pe-4 bg-verde-claro rounded fs-8 text-dark fw-bold '
            >
              Contato
            </a>
          </li>
        </ul>
        {/* end::Nav */}
      </div>
      {/* end::Container */}
    </div>
  )
}

export {Footer}
